import React from 'react'; // eslint-disable-line
import Select from 'react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { withRouter } from 'react-router-dom';
import EditInput from '../../components/forms/EditInput';
import constants from '../../constants';
import GeneralSection from '../../components/common/GeneralSection';
import VersionBox from '../../components/common/VersionBox';
import _actions from '../../actions';
import PreviewDiscover from '../../components/preview/PreviewDiscover';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import SortablePageSectionsList from '../../components/pages/SortablePageSectionsList';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';
import LargeModal from '../modals/LargeModal';
import SmallModal from '../modals/SmallModal';

const FMSCategoryName = 'Event Registration';

export class DiscoverModule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuItem: {},
            module: {},
            index: props.match.params.section === 'layout' ? 1 : 0,
            sectionsLoading: true,
            showUpsellModal: false,
            showPreview: true,
        };
        this.updateMenuItemFromEvent = this.updateMenuItemFromEvent.bind(this);
        this.updateModuleFieldWithValue = this.updateModuleFieldsWithValues.bind(this);
        this.updateModuleFromEvent = this.updateModuleFromEvent.bind(this);
        this.updateModuleFeaturedId = this.updateModuleFeaturedId.bind(this);
        this.saveUpdatedModule = this.saveUpdatedModule.bind(this);
        this.handleDeleteContentSection = this.handleDeleteContentSection.bind(this);
        this.handleDisplayOrderChange = this.handleDisplayOrderChange.bind(this);
        this.handleAddContentSection = this.handleAddContentSection.bind(this);
        this.handleSectionChange = this.handleSectionChange.bind(this);
        this.handleAddContent = this.handleAddContent.bind(this);
        this.handleAddDivider = this.handleAddDivider.bind(this);
        this.handleDeleteContent = this.handleDeleteContent.bind(this);
        this.handleUpdateContent = this.handleUpdateContent.bind(this);
        this.canReorderSubItems = this.canReorderSubItems.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId, true);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
        this.props.actions.getModuleByTypeAndForms(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Discover'; }).Id);
        this.props.actions.getPagesforProject(this.props.match.params.projectId);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.modules.select.id
            && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Discover'; }).Id
            && this.props.modules.select.enabled) {
            if (this.props.alerts.data.length > 0 && this.props.alerts.data.find((m) => { return m.id === 'module-disabled'; })) {
                this.props.actions.clearAlert('module-disabled');
            }
        }
        if (!prevState.isLoaded) {
            if (this.props.modules.select.id
                && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Discover'; }).Id
                && !this.props.modules.select.enabled) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.discover.error1'),
                    linkText: i18n.t('enableHere'),
                    link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
                    view: '/modules/discover',
                    type: 'warning',
                    id: 'module-disabled',
                });
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isLoaded: true });
            }
        }
        if (!this.props.forms.inProgress
            && !this.props.modules.inProgress
            && !this.state.formsLoaded
            && this.props.forms.filtered.length === 0
            && this.props.versions.select.mediaUrl === '') {
            this.props.actions.addAlert({
                message: `${i18n.t('forms.error')} "${FMSCategoryName}".`,
                view: '/modules/discover',
                type: 'error',
                id: 'forms-missing-discover',
            });
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ formsLoaded: true });
        }
        if (prevProps.forms.inProgress && !this.props.forms.inProgress) {
            const eventForms = this.props.forms.filtered.filter((form) => { return form.categories.some((cat) => { return cat === '00000003-b1e5-4001-8f82-e56bda04af82'; }) && form.isCurrentEvent === true; });
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                formsLoaded: true,
                allForms: this.props.forms.filtered,
                eventForms,
            });
        }
        if (prevProps.pages.dropInProgress && !this.props.pages.dropInProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                pagesLoaded: true,
                allPages: this.props.pages.dropdown,
            });
        }
        if (prevProps.modules.inProgress && !this.props.modules.inProgress) {
            this.loadProjectMedia();
        }
        if (prevProps.media.inProgress && !this.props.media.inProgress) {
            if (this.props.media.error) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.sermons.error-get-media-failure'),
                    linkText: 'Fix here',
                    link: `/projects/${this.props.match.params.projectId}/modules/sermons`,
                    view: '/modules/discover',
                    type: 'error',
                    id: 'get-media-failure',
                });
            }
        }
        if ((!this.props.menuItems.inProgress
            && prevProps.menuItems.inProgress)
            || (!this.props.modules.inProgress
                && prevProps.modules.inProgress)) {
            let menuItem = this.props.menuItems.data !== []
                && this.props.modules.select.moduleType === constants.ModuleType.find((c) => { return c.Name === 'Discover'; }).Id
                ? this.props.menuItems.data
                    .find((mi) => {
                        return mi.type === 2
                            && mi.subType.toUpperCase() === this.props.modules.select.pageId.toUpperCase();
                    })
                : '';
            menuItem = menuItem || {};
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ menuItem });
        }
        if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ module: this.props.modules.select });
        }
        if ((!this.props.pages.inProgress && prevProps.pages.inProgress && this.props.modules.select?.pageId)
            || (!this.props.modules.inProgress && prevProps.modules.inProgress && this.props.pages.data?.length > 0)) {
            const temp = this.props.pages.data.find((m) => { return m.id === this.props.modules.select.pageId; });
            // eslint-disable-next-line react/no-did-update-set-state
            if (typeof (temp) !== 'undefined') this.setState({ sections: temp.contentSections, sectionsLoading: false });
        }
        if (!this.props.publish.updatedNew && prevProps.publish.updatedNew) {
            this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
            this.props.actions.getModuleByTypeAndForms(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Discover'; }).Id, true);
        }
    }

    formatMediaItemsForSelect = (items) => {
        const formattedItems = [];
        formattedItems.push({
            label: i18n.t('modules.discover.sermon-select'),
            value: 'auto',
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            formattedItems.push({
                label: item.title,
                value: item.guid,
            });
        }
        return formattedItems;
    }

    formatFormsForSelect = (items) => {
        const formattedItems = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            formattedItems.push({
                label: item.name,
                value: item.id,
            });
        }
        return formattedItems;
    }

    showUpsellModal = () => {
        this.setState({ showUpsellModal: true });
    }

    formatPagesForSelect = (items) => {
        const formattedItems = [];
        formattedItems.push({
            label: i18n.t('pages.tapType5'),
            value: '5',
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            if (item.id !== this.state.module.pageId) {
                formattedItems.push({
                    label: item.name,
                    value: item.id,
                });
            }
        }
        return formattedItems;
    }

    handleTabChange = (event, index) => {
        switch (index) {
            case 0:
                this.props.history.push(`/projects/${this.props.match.params.projectId}/modules/discover/configure`);
                this.setState({ index: 0 });
                break;
            case 1:
                this.props.history.push(`/projects/${this.props.match.params.projectId}/modules/discover/layout`);
                this.setState({ index: 1 });
                break;
            default:
                break;
        }
    }

    updateModuleFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.checked;
        let activeSermons = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Sermons'; }).Id; });
        activeSermons = activeSermons.filter((module) => { return module.enabled === true; });
        if (changedValue && fieldName === 'showFeatured' && activeSermons.length === 0) {
            this.props.actions.addAlert({
                message: i18n.t('modules.sermons.error1'),
                linkText: i18n.t('enableHereCaps'),
                link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
                view: '/modules/discover',
                type: 'warning',
                dismissable: true,
            });
        } else if (changedValue && fieldName === 'showUpcomingEvents' && this.state.eventForms?.length === 0) {
            this.props.actions.addAlert({
                message: `${i18n.t('forms.error')} "${FMSCategoryName}".`,
                view: '/modules/discover',
                type: 'error',
                id: 'forms-missing',
                dismissable: 'true',
            });
        } else {
            const newState = this.state.module;
            newState[fieldName] = changedValue;
            this.setState({ module: { ...newState } });
            this.saveUpdatedModule(this.state.module, fieldName, changedValue);
        }
    }

    updateModuleFeaturedId(value) {
        const fieldsToBeUpdated = [
            {
                Name: 'featuredId',
                Value: value.value === 'auto' ? null : value.value,
            },
            {
                Name: 'featuredType',
                Value: value.value === 'auto' ? constants.FeaturedType.find((n) => { return n.Name === 'Latest'; }).Id : constants.FeaturedType.find((n) => { return n.Name === 'Featured'; }).Id,
            }];
        this.updateModuleFieldsWithValues(fieldsToBeUpdated);
    }

    updateModuleFieldsWithValues(fields) {
        // eslint-disable-next-line no-restricted-syntax
        for (const field of fields) {
            const newState = this.state.module;
            newState[field.Name] = field.Value;
            this.setState({ module: { ...newState } });
            this.saveUpdatedModule(this.state.module, field.Name, field.Value);
        }
    }

    loadProjectMedia() {
        this.props.actions.getProjectMedia(this.props.match.params.projectId);
    }

    updateMenuItemFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.discover.discover');
        if (changedValue !== '') {
            this.setState((prevState) => {
                return {
                    menuItem: {
                        ...prevState.menuItem,
                        title: changedValue,
                    },
                };
            });
            this.props.actions.updateMenuItemParameter(
                this.props.match.params.projectId,
                this.state.module.pageId,
                2,
                fieldName,
                changedValue,
            );
        }
    }

    saveUpdatedModule(module, field, val) {
        this.props.actions.updateModuleParameter(
            this.props.match.params.projectId,
            this.state.module.moduleType,
            field,
            val,
        );
    }

    // eslint-disable-next-line react/sort-comp
    handleDeleteContentSection(e) {
        this.setState({ sectionsLoading: true });
        this.props.actions.deleteContentSection(e, this.props.match.params.projectId);
    }

    handleAddContentSection() {
        this.setState({ sectionsLoading: true });
        this.props.actions.addContentSectionToPage(this.props.modules.select.pageId, this.props.match.params.projectId);
    }

    handleDisplayOrderChange(e) {
        this.props.actions.reorderPageSections(this.props.modules.select.pageId, this.props.match.params.projectId, e);
    }

    handleSectionChange(section) {
        // this isn't strictly necessary here, but keeping in sync with PagesModule
        this.setState({ sectionsLoading: true });
        this.props.actions.updateContentSection(section, this.props.match.params.projectId);
    }

    handleAddContent(content) {
        this.setState({ sectionsLoading: true });
        this.props.actions.addContentToSection(content, this.props.match.params.projectId);
    }

    handleAddDivider(precedingId, sectionId) {
        this.setState({ sectionsLoading: true });
        const divider = { contentSectionId: sectionId, contentType: 102, precedingContentId: precedingId };
        this.props.actions.addContentToSection(divider, this.props.match.params.projectId);
    }

    handleDeleteContent(id) {
        this.setState({ sectionsLoading: true });
        this.props.actions.deleteContent(id, this.props.match.params.projectId);
    }

    handleUpdateContent(content) {
        this.setState({ sectionsLoading: true });
        this.props.actions.updateContent(content, this.props.match.params.projectId);
    }

    canReorderSubItems(subItems) {
        const contentLists = subItems.map(s => s.contents.filter(c => c !== undefined)).filter(s => s.length > 0);

        for (let i = 0; i < contentLists.length; i++) {
            const contents = contentLists[i];
            const sermonIndex = contents.findIndex(c => c.contentType === 101);
            if (sermonIndex > 0) {
                return false;
            }
        }

        return true;
    }

    render() {
        const mediaItems = this.props.media.select.url
            ? this.formatMediaItemsForSelect(this.props.media.select.items)
            : [];
        let previewDiscover = null;
        const formItems = this.state.formsLoaded ? this.formatFormsForSelect(this.state.allForms) : [];
        const pagesItems = this.state.pagesLoaded ? this.formatPagesForSelect(this.state.allPages) : [];
        let selectedFeaturedId = '';
        if (mediaItems.length > 0) {
            selectedFeaturedId = this.state.module.featuredId ? this.state.module.featuredId : '';
            if (selectedFeaturedId === '') {
                selectedFeaturedId = 'auto';
            }
        }

        let activeCheckin = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Check-In'; }).Id; });
        activeCheckin = activeCheckin.filter((module) => { return module.enabled === true; });
        let activeSermons = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Sermons'; }).Id; });
        activeSermons = activeSermons.filter((module) => { return module.enabled === true; });
        let bodyForm = '';
        const upsell = (<SmallModal alertView="pages-modal" visible={this.state.showUpsellModal} close={() => { this.setState({ showUpsellModal: false }); }} >
            <div className='modal-content text-center' >Page limit exceeded</div>
        </SmallModal>);
        if (this.state.module.enabled) {
            if (this.state.index === 0) {
                previewDiscover = (
                    <PreviewDiscover
                        media={this.props.media}
                        module={this.state.module}
                        forms={this.state.eventForms}
                        menuItem={this.state.menuItem}
                        actionColor={this.props.versions.select.actionColor}
                        accentColor={this.props.versions.select.accentColor}
                        secondaryText={this.props.versions.select.secondaryText}
                        primaryText={this.props.versions.select.primaryText}
                        menuStyle={this.props.versions.select.menuStyle}
                        menuItems={this.props.menuItems.data}
                        checkin={
                            this.props.flags.results?.chMSIntegration
                            && this.props.flags.results?.chMSCheckIn
                            && activeCheckin.length > 0
                        }
                    />
                );
            }

            bodyForm = (
                <div
                    data-qa="discover-module-page"
                    id="discover-module-page"
                    className="form-wrapper"
                >
                    <h1
                        data-qa="discover-module-header"
                        id="discover-module-header"
                    >
                        {i18n.t('modules.discover.header')}
                    </h1>
                    <p
                        data-qa="discover-module-subhead"
                        id="discover-module-subhead"
                        className="lead"
                    >
                        {i18n.t('modules.discover.subtitle')}
                    </p>
                    {this.props.flags?.results?.customContent
                        && (
                            <Tabs
                                className="configure-tabs"
                                value={(this.state.index === 0 || this.state.index === 1) ? this.state.index : false}
                                onChange={this.handleTabChange}
                                textColor="primary"
                            >
                                <Tab
                                    className="configure-tab"
                                    value={0}
                                    disableFocusRipple
                                    disableRipple
                                    label={i18n.t('modules.discover.section1')}
                                />
                                <Tab
                                    className="configure-tab"
                                    value={1}
                                    disableFocusRipple
                                    disableRipple
                                    label={i18n.t('modules.discover.tab2')}
                                />
                            </Tabs>
                        )}
                    {
                        this.state.index === 1
                        && (
                            <div>
                                <GeneralSection
                                    name={i18n.t('modules.discover.section4')}
                                    sectionClass="edit-module-name"
                                />
                                <SortablePageSectionsList
                                    flags={this.props.flags}
                                    sections={this.state.sections}
                                    canReorderSubItems={this.canReorderSubItems}
                                    onItemsDisplayOrderChange={this.handleDisplayOrderChange}
                                    onSingleItemChange={this.handleSectionChange}
                                    deleteContentSection={this.handleDeleteContentSection}
                                    addContentSection={this.handleAddContentSection}
                                    addDivider={this.handleAddDivider}
                                    addContent={this.handleAddContent}
                                    updateContent={this.handleUpdateContent}
                                    deleteContentBlock={this.handleDeleteContent}
                                    changing={this.state.sectionsLoading}
                                    formsItems={formItems}
                                    formsObjects={this.props.forms.filtered}
                                    pagesItems={pagesItems}
                                    upsell={this.showUpsellModal}
                                    handleShowPreview={() => {}} // It's mandatory for component, so added the void
                                />
                            </div>
                        )
                    }
                    {this.state.index === 0
                        && (
                            <div>
                                <GeneralSection
                                    sectionClass="edit-module-name module-display-settings-list"
                                    name={i18n.t('name')}
                                >
                                    <div
                                        id="module-display-setting"
                                        className="module-display-setting"
                                    >
                                        <EditInput
                                            containerId="edit-module-name-wrap"
                                            containerClass="edit-module-name-wrap"
                                            name="title"
                                            labelText=""
                                            value={this.state.menuItem !== {} && this.state.menuItem.title ? this.state.menuItem.title : ''}
                                            onBlur={this.updateMenuItemFromEvent}
                                            charLimit={12}
                                            onReturnDown={this.updateMenuItemFromEvent}
                                            actionClass="edit-module-name-action"
                                            dataqa="discover-module-name"
                                            placeholder={i18n.t('modules.discover.discover')}
                                            menuTitle
                                        />
                                        {this.props.flags.results?.userSelectedIcons
                                            && (
                                                <HorizontalFormContainer
                                                    inputClass="module-display-setting__setting"
                                                    title="Menu Icon"
                                                >
                                                    <UserSelectedIconSelect
                                                        id={this.state.menuItem.subType}
                                                        type={this.state.menuItem.type}
                                                        autoUpdate
                                                    />
                                                </HorizontalFormContainer>
                                            )}
                                    </div>

                                    <div
                                        id="show-featured"
                                        className={`module-display-setting ${this.state.module.showFeatured ? 'module-setting-on' : 'module-setting-off'}`}
                                    >
                                        <HorizontalFormContainer
                                            data-qa="show-featured"
                                            inputClass="module-display-setting__toggle"
                                            title={i18n.t('modules.discover.section2.label1')}
                                        >

                                            <OnOffSwitch
                                                name="showFeatured"
                                                buttonClass="toggle checkbox md-checkbox large-switch"
                                                onChange={this.updateModuleFromEvent}
                                                isToggleOn={this.state.module.showFeatured}
                                                disabled={activeSermons.length === 0 || mediaItems.length === 0}
                                                tooltipText={i18n.t('modules.sermons.discover.connect')}
                                            />
                                        </HorizontalFormContainer>

                                        <div
                                            data-qa="show-featured__selector"
                                            id="show-featured__selector"
                                            className="module-display-setting__options"
                                        >
                                            <h4 data-qa="show-featured-title">{i18n.t('modules.discover.section2.label2')}</h4>
                                            <Select
                                                id="featured-selector"
                                                options={mediaItems}
                                                onChange={this.updateModuleFeaturedId}
                                                className="form-selector"
                                                classNamePrefix="form-selector"
                                                value={mediaItems.length > 0 ? mediaItems.find((f) => { return f.value === selectedFeaturedId; }) : ''}
                                                name="featuredId"
                                                clearable={false}
                                                disabled={mediaItems.length === 0}
                                            />
                                        </div>
                                        <HorizontalFormContainer
                                            data-qa="show-upcoming-events"
                                            inputClass="module-display-setting__toggle"
                                            title={i18n.t('modules.discover.section3')}
                                        >
                                            <OnOffSwitch
                                                name="showUpcomingEvents"
                                                buttonClass="toggle checkbox md-checkbox large-switch"
                                                onChange={this.updateModuleFromEvent}
                                                isToggleOn={this.state.module.showUpcomingEvents}
                                            />
                                        </HorizontalFormContainer>
                                    </div>
                                </GeneralSection>
                            </div>
                        )}
                    {this.state.showUpsellModal && upsell}
                </div>
            );
        }
        return (

            <VersionBox
                name={this.props.versions.select.name}
                versionNumber={this.props.versions.select.version}
                saving={this.props.modules.inProgress}
                justSaved={this.props.modules.justSaved}
                menuSection="Modules"
                menuItem="DiscoverModule"
                previewCssClass="modules_discover"
                previewChild={previewDiscover}
                showPreview={this.state.showPreview}
                x
            >
                <div id="discover-module-page" className="content-inside">
                    {bodyForm}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DiscoverModule));
